"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Selectable = _interopRequireDefault(require("@commerce-ui/core2/Selectable"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Checkmark = _interopRequireDefault(require("../Checkmark"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ItemRowCheckmark = function ItemRowCheckmark(props) {
  return __jsx(_Selectable["default"], props, function (_ref) {
    var disabled = _ref.disabled,
      highlighted = _ref.highlighted,
      selected = _ref.selected,
      label = _ref.label,
      optionsArray = _ref.optionsArray,
      allVisible = _ref.allVisible,
      option = _ref.option,
      _ref$isColor = _ref.isColor,
      isColor = _ref$isColor === void 0 ? false : _ref$isColor;
    var optionIndex = optionsArray.map(function (option) {
      return option.label;
    }).indexOf(label);
    return __jsx(_Box["default"], {
      sx: _objectSpread({
        width: "100%",
        minWidth: "250px",
        display: optionIndex > 9 ? allVisible ? "flex" : "none" : "flex",
        py: "s5",
        alignItems: "center",
        font: "body2",
        opacity: disabled ? 0.5 : 1,
        justifyContent: "space-between"
      }, props.rootStyles)
    }, __jsx(_Box["default"], {
      sx: {
        color: selected ? "active" : "main"
      }
    }, label, " ", (option === null || option === void 0 ? void 0 : option.amount) && !isColor && "(".concat(option === null || option === void 0 ? void 0 : option.amount, ")")), __jsx(_Checkmark["default"], props));
  });
};
var _default = ItemRowCheckmark;
exports["default"] = _default;